export const TIMESHEET_QUERY_KEYS = {
  TIMESHEET_LOG: "timesheet",
  TIMESHEET_REVIEW: "timesheet_review",
  TIMESHEET_UNLOCK: "timesheet_unlock",
  DAILY_CAPACITY: "daily_capacity",
  MONTHLY_TIMESHEET: "monthly_timesheet",
  MONTHLY_TIMESHEET_REVIEW: "monthly_timesheet_review",
  MONTHLY_TIMESHEET_LOG: "monthly_timesheet_log",
  PROJECTS: "projects",
  JOBS: "jobs",
  MILESTONES: "milestones",
};
export const TIMESHEET_REVIEW_QUERY_KEYS = {
  TIMESHEET_REVIEW: "timesheet_review",
};
